import { render, staticRenderFns } from "./UserNewPassword.vue?vue&type=template&id=6701abb5&scoped=true&"
import script from "./UserNewPassword.vue?vue&type=script&lang=js&"
export * from "./UserNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserNewPassword.vue?vue&type=style&index=0&id=6701abb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701abb5",
  null
  
)

export default component.exports